module.exports = __webpack_public_path__ + "img/icon_laohuang_logo232.e6409ede.png";